import React, { useEffect } from "react";
import i18n from "micro-i18n";
import PropTypes from "prop-types";
import { connect } from "unistore/preact";
import { actions } from "actions";
import { isArray, isNullOrUndefOrEmpty, toObject } from "utils";
import RecommendItem from "components/recommend/RecommendItem";
import { JotType, WidgetState } from "consts";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/recommend/Recommend.scss';

const RecommendType = {
  IMAGE_COLS: "image-cols",
  IMAGE_LIST: "image-list",
};

const Recommend = ({
  jot,
  finishData,
  resultIndex,
  widgetState,
  onRestart,
  headingLevel = 3,
  creEnabled = false,
  testContentRecAtEndEnabled = false,
  isCarousel = false,
}) => {
  if (isNullOrUndefOrEmpty(finishData)) {
    return null;
  }
  //creEndEnabled is only true when the following states are matched,
  // 1. natures contains Natures.ContentRecommendationEngineEndEnabled,
  // 2. widgetState === WidgetState.ContentRecSlide
  // 3. onRestart optional method is passed to Recommend component
  const creEndEnabled =
    testContentRecAtEndEnabled &&
    !isNullOrUndefOrEmpty(onRestart) &&
    (widgetState === WidgetState.ContentRecSlide || isCarousel);

  if (!creEnabled && !creEndEnabled) {
    return null;
  }

  const { contentRec = [] } = toObject(finishData);

  const hasRecommendations = isArray(contentRec) && contentRec.length > 0;

  const trimmedContentRec = hasRecommendations ? contentRec.slice(0, 3) : [];
  const recLength = trimmedContentRec.length || 0;
  const recommendType = isCarousel || recLength < 3 ? RecommendType.IMAGE_LIST : RecommendType.IMAGE_COLS;
  const isImgCols = recommendType === RecommendType.IMAGE_COLS;
  const isImgList = recommendType === RecommendType.IMAGE_LIST;

  //recommendations list visibility: Final check based on whether contentRec has the appropriate length.
  const showRecommendations = (creEnabled || creEndEnabled) && hasRecommendations && recLength > 0;

  useEffect(() => {
    showRecommendations &&
      ((creEndEnabled && widgetState === WidgetState.ContentRecSlide) || (creEnabled && resultIndex === 0)) &&
      jot({
        space: "poll",
        type: JotType.ContentRecommendationShown,
      });
  }, [showRecommendations, resultIndex, creEnabled, creEndEnabled, widgetState]);

  return showRecommendations ? (
    <div className={`csw-recommend ${recommendType}`}>
      <div className="csw-recommend-wrapper csw-scroll-section">
        <div className="csw-recommend-heading" role="heading" aria-level={headingLevel}>
          {i18n.t("RECOMMEND_SUGGESTED_FOR_YOU")}
        </div>

        <ul className="csw-recommend-list">
          {trimmedContentRec.map((content, i) => (
            <li key={`recommended-list-item-${i}`}>
              <RecommendItem
                content={content}
                recommendType={recommendType}
                isImgList={isImgList}
                isImgCols={isImgCols}
              />
            </li>
          ))}
        </ul>

        <div className="csw-scroll-shadow" />
      </div>

      {creEndEnabled && (
        <div className="csw-recommend-btns csw-btns csw-stretch">
          <button
            type="button"
            className="csw-btn csw-btn-primary csw-btn-restart outline"
            onClick={onRestart}
            tabIndex="0"
          >
            {i18n.t("BUTTON_ANSWER_MORE_QUESTIONS")}
          </button>
        </div>
      )}
    </div>
  ) : null;
};

Recommend.propTypes /* remove-proptypes */ = {
  jot: PropTypes.func.isRequired,
  finishData: PropTypes.object,
  resultIndex: PropTypes.number,
  widgetState: PropTypes.number,
  onRestart: PropTypes.func,
  headingLevel: PropTypes.number,
  creEnabled: PropTypes.bool,
  testContentRecAtEndEnabled: PropTypes.bool,
  isCarousel: PropTypes.bool,
};

export default connect("finishData,resultIndex,widgetState", actions)(Recommend);
